import { MixpanelBasePayload } from '../mix-panel-context';

export interface ActionStartedPayload extends MixpanelBasePayload {
  action: string;
}

export function generateActionStartedProperties(payload: ActionStartedPayload): ActionStartedPayload {
  return payload;
}
